import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6lu/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6lu/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres6lu/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres6lu/detail/' + params)
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres6lu/sendApprove', sendParams)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres6lu/dropdowns')
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6lu/index.js